module.exports = __webpack_public_path__ + "static/media/reflective-listening.c3b141c4.png";